import {assign} from 'xstate'
import moment from 'moment'
import {nextStep} from 'utils/step_utils'
import i18n from 'i18n/config'

const stepName  = 'detailsStep'

const updateForm = assign({detailsForm: (ctx, e) => e.form})
const cleanError = assign({error: null})
const setError = assign({error: i18n.t('details_state.details_form_error')})
const setDetailsValues = assign({detailsValues: (ctx, e) => e.data})

const submitForm = (ctx) => {
  return new Promise((resolve, reject) => {
    ctx.detailsForm.submitForm()
      .then(ctx.detailsForm.validateForm)
      .then(errors => {
        const isValid = Object.keys(errors).length === 0
        if (isValid) {
          resolve(ctx.detailsForm.values)
        } else {
          reject(errors)
        }
      })
  })
}

const detailsState = (config) => {
  return {
    initial: 'init',
    states: {
      init: {
        on: {'': {
          target: 'waitingDetailsResponses',
          actions: cleanError
        }},
      },
      waitingDetailsResponses: {},
      formValidation: {
        invoke: {
          src: submitForm,
          onDone: {
            target: '#purchase.reserving',
            actions: [setDetailsValues]
          },
          onError: {
            target: 'waitingDetailsResponses',
            actions: [setError]
          }
        }
      }
    },
    on: {
      DETAILS_FORM_CHANGE: {
        actions: [updateForm, cleanError]
      },
      NEXT_STEP_CLICK: [
        {
          target: '.formValidation'
        }
      ],
      RESERVATION_REQUEST: [
        {
          target: '.formValidation'
        }
      ]
    }
  }
}

export default detailsState
